<template>
<div class="basesingle-container">

  <gtool
    :handleToolSide="handleToolSide"
    :handleToolHeadBtn="handleToolHeadBtn"
    :title="title"
    :toolbarIcon="toolbarIcon"
    :toolbarColor="toolbarColor"
    :isLoading="isLoading"
    >
      <v-spacer></v-spacer>
      <ToolbarActions :actions="actions" />
      <ViewSelector
        :hasDetail="true"
        :hasMap="hasMap"
        :hasRelations="hasRelations"
        :hasEdit="hasEdit"
        :value="singleView"
        :selectView="selectView"
      />
  </gtool>

  <SingleView
    :key="`${source}-${id}`"
    :source="source"
    :doc="doc.form"
    :form="form"
    :headers="headers"
    :updateField="updateField"
    :isLoading="isLoading"
    :hideFormAlert="hideFormAlert"
    :context="formContext"
    :singleViewType="singleView"
    :onTabSelected="onTabSelected"
    />

    <Popup
    :key="`${source}-${id}-search-dialog`"
      v-if="searchDialog"
      :dialog="searchDialog"
      :toggleAdvanced="() => {}"
      :handleSave="handleSearch"
      :handleClose="handleSearchClose"
      :handleReset="handleSearchReset"
    >
      <v-flex xs12>
        <v-text-field
          v-model.trim="quickSearch"
          label="Trouver..."
          hint="Recherche rapide sur tous les champs"
        />
      </v-flex>
    </Popup>
</div>
</template>

<script>
import SingleView from '@/components/single/SingleView'
import ToolBar from '@/components/ToolBar'
import ToolbarActions from '@/components/ToolbarActions'
import ViewSelector from '@/components/ViewSelector'
import Popup from '@/components/Popup'
import DataForm from '@/components/form/DataForm'
import Form from '@/components/adhoc/Form'
import Confirm from '@/components/adhoc/Confirm'
import { create } from 'vue-modal-dialogs'
import { filterActions } from '@/utils'
import merge from 'deepmerge'

// Create the dialog function with no other arguments to
// tell vue-moda-dialogs to treat the first argument as the data object
const adhocForm = create(Form)
const actionConfirm = create(Confirm)

export default {
  components: {
    SingleView,
    gtool: ToolBar,
    ToolbarActions,
    ViewSelector,
    DataForm,
    Popup,
  },
  data: () => ({
    toolbarColor: 'blue darken-4',
    toolbarIcon: 'chevron_left',
    advancedSearch: false,
    quickSearch: null,
  }),
  computed: {
    isLoading () { return this.$store.getters[`${this.source}/isLoading`] },
    singleView () { return this.$store.getters[`${this.source}/singleView`] },
    scope () { return this.$store.getters['auth/scope'] },
    doc () { return this.$store.getters[`${this.source}/doc`] },
    headers () { return this.doc.list.headers },
    form () { return this.$store.getters[`${this.source}/form`] },
    currentRelation () { return this.form.currentRelation },
    searchForm () { return this.$store.getters[`${this.currentRelation}/doc`].list.search },
    search () { return this.$store.getters[`${this.currentRelation}/search`] },
    searchDialog () { return this.search ? this.search.dialog : null },
    editMode () { return this.singleView === 'edit' },
    relationMode () { return this.singleView === 'relation' },
    title () { return `Modifier ${this.doc.form.name}` },
    hasMap () { return this.doc.list.hasMap },
    hasRelations () { return this.doc.form.relations.length > 0 },
    hasEdit () { return this.doc.form.fields.length > 0 },
    formContext () {
      return {
        params: this.doc.params.fetchOne,
        id: this.id,
      }
    },
    actions () {
      let payload = {
        accessors: {},
        context: this.formContext,
      }
      let context = {
        edit: this.editMode,
        relation: this.relationMode,
        ...this.form.data,
      }
      let valid = filterActions(this.doc.form.actions, context, this.scope)
      return valid.map(action => {
        let modifiedPayload = merge(payload, {context: action.context ? action.context : {}})
        // restore data!
        modifiedPayload.data = this.form.data
        const callBack = () => (
          action.adhoc
            ? this.runAdHoc(action.adhoc)
            : this.callBackMiddleware(action.dispatch, modifiedPayload)
        )
        return {
          ...action,
          callBack,
        }
      })
    },
  },
  methods: {
    handleDelete (data) {
      let payload = {
        accessors: {},
        context: this.formContext,
        data,
      }
      this.$store.dispatch(`${this.source}/delete`, payload)
    },
    updateField (data) {
      let payload = {
        accessors: {},
        context: this.formContext,
        data,
      }
      this.$store.dispatch(`${this.source}/updateFormField`, payload)
    },
    handleToolSide () {
      let payload = {
        accessors: {},
        context: this.formContext,
        data: {},
      }
      this.$store.dispatch('ui/toggleDrawer', payload)
    },
    handleToolHeadBtn () {
      // let payload = {
      //   accessors: {},
      //   context: this.formContext,
      //   data: this.form.data,
      // }
      this.$router.go(-1)
      // this.$store.dispatch(`${this.source}/goToList`, payload)
    },
    hideFormAlert () {
      let payload = {
        accessors: {},
        context: this.formContext,
        data: {},
      }
      this.$store.dispatch(`${this.source}/hideFormAlert`, payload)
    },
    selectView (data) {
      let payload = {
        accessors: {},
        context: this.formContext,
        data,
      }
      this.$store.dispatch(`${this.source}/setSingleView`, payload)
    },
    runAdHoc (form) {
      let foundForm = this.doc.form.adhoc[form]
      if (foundForm !== undefined) {
        adhocForm({
          doc: foundForm,
        })
          .then(data => {
            console.log('ok', data)
            let payload = {
              accessors: {},
              context: this.formContext,
              data,
            }
            this.$store.dispatch(foundForm.dispatch, payload)
          })
          .catch(error => {
            console.log('error', error)
          })
      }
    },
    callBackMiddleware (dispatch, payload) {
      let confirm = payload.context.confirm || false
      if (confirm) {
        console.log('we need to confirm this:', payload)
        actionConfirm({
          question: 'Voulez-vous confirmer cette action?',
        })
          .then(data => {
            console.log('ok', dispatch, payload)
            this.$store.dispatch(dispatch, payload)
          })
          .catch(error => {
            console.log('error', error)
          })
      } else {
        this.$store.dispatch(dispatch, payload)
      }
    },
    onTabSelected (data) {
      let payload = {
        accessors: {},
        context: this.formContext,
        data,
      }
      this.quickSearch = this.$store.getters[`${data}/quickSearch`]
      this.$store.dispatch(`${this.source}/setCurrentRelation`, payload)
    },
    handleSearch () {
      this.$store.dispatch(`${this.currentRelation}/smartSearch`, this.quickSearch)
      this.handleSearchClose()
    },
    handleSearchClose () {
      let payload = {
        accessors: {},
        context: this.formContext,
        data: {},
      }
      this.$store.dispatch(`${this.currentRelation}/closeSearch`, payload)
    },
    handleSearchReset () {
      let payload = {
        accessors: {},
        context: this.formContext,
        data: {},
      }
      this.quickSearch = null
      this.$store.dispatch(`${this.currentRelation}/smartSearch`, null)
      this.$store.dispatch(`${this.currentRelation}/resetSearch`, payload)
    },
    updateSearchField (data) {
      let payload = {
        accessors: {},
        context: this.formContext,
        data,
      }
      this.$store.dispatch(`${this.currentRelation}/updateSearchField`, payload)
    },
  },
  props: {
    source: String,
    label: String,
    id: {
      type: [String, Number],
      required: true,
    },
  },

  beforeRouteUpdate (to, from, next) {
    // react to route changes...
    // don't forget to call next()
  },

  beforeMount () {
    let payload = {
      accessors: {},
      context: this.formContext,
      data: parseInt(this.id),
    }
    this.$store.dispatch(`${this.source}/fetchOne`, payload)
  },
}
</script>
<style>
  .basesingle-container {
    position: relative;
    height: 100%;
    width: 100%;
  }
</style>
